import React from "react";
import { MDBBreadcrumb, MDBBreadcrumbItem } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import useLocale from "../util/i18n";

export type Breadcrumb = string | { link: string, label: string };

const CrumbsContext = React.createContext<[(crumbs: Array<Breadcrumb>) => void, Array<Breadcrumb>]>([() => { }, []]);

export function CrumbsProvider(props: { children: JSX.Element }) {
    const { 0: breadcrumbs, 1: setBreadcrumbs } = React.useState<Array<Breadcrumb>>([]);
    return (
        <CrumbsContext.Provider value={[setBreadcrumbs, breadcrumbs]}>
            {props.children}
        </CrumbsContext.Provider>
    );
}

export function useCrumbs() {
    return React.useContext(CrumbsContext);
}

export default function Breadcrumbs(props: { className?: string }) {
    const { 1: breadcrumbs } = useCrumbs();
    const { 0: __ } = useLocale();
    return (
        <MDBBreadcrumb className={'container ' + (props.className || '')}>
            {breadcrumbs.map((item, index) => (
                <MDBBreadcrumbItem key={'b' + index}>
                    {typeof item === 'string' || !item.link ? (
                        <span>{__(typeof item === 'string' ? item : item.label)}</span>
                    ) : (<Link to={item.link}>{__(item.label)}</Link>)}
                </MDBBreadcrumbItem>
            ))}
        </MDBBreadcrumb>
    );
}
